import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";
import clsx from "clsx";

import styles from "./tabsSection.module.scss";
import Dropdown from "@components/TabsSection/Dropdown/dropdown";
import LocalizedLink from "@components/LocalizedLink/localizedLink";
import locales from "@translations/locales";

const TabsSection = ({ tabs, defaultTab, locale, pageSlug, hasTitle = true }) => {
  const [activeTab] = useState(tabs ? tabs[defaultTab] : null);

  useEffect(() => {
    const tab = window.location.hash.replace(/^#/, "");
    const validTabs = tabs ? Object.keys(tabs) : [];

    if (validTabs.includes(tab) && tab !== defaultTab) {
      const path = `/${pageSlug}/${tab}`;
      const isDefaultLocale = locales[locale] && locales[locale].default;

      navigate(isDefaultLocale ? path : `/${locale}${path}`, { replace: true });
    }
  }, [tabs, defaultTab, locale, pageSlug]);

  if (tabs === null || !Object.keys(tabs).length) {
    return null;
  }

  return (
    <div className={styles.tabsSection}>
      <nav className={styles.tabsSection__tabsDesktop}>
        {Object.keys(tabs).map(key => (
          <LocalizedLink
            to={`/${pageSlug}/${key}`}
            locale={locale}
            className={clsx(
              styles.tabsSection__tab,
              activeTab.title === tabs[key].title && styles.tabsSection__tabSelected
            )}
            key={key}
          >
            {tabs[key].title}
          </LocalizedLink>
        ))}
      </nav>
      <nav className={styles.tabsSection__tabsMobile}>
        <Dropdown
          defaultValue={activeTab}
          values={tabs}
          locale={locale}
          pageSlug={pageSlug}
        />
      </nav>
      <section className={styles.tabsSection__panel}>
        {hasTitle && <h1>{activeTab.title}</h1>}
        {activeTab.components &&
          activeTab.components.map((component, index) =>
            React.createElement(component, { key: index })
          )}
      </section>
    </div>
  );
};

export default TabsSection;
